import { useEffect, useRef, useState } from "preact/hooks";
import styled, { keyframes } from "styled-components";
import { hasClick, clickProduct } from "./localStorage";

const Taobao = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAD8ElEQVRIS8WXT2gdVRTGf+fiIosILRSqoJCiiwgVG+iiUsV5rykWjBgwhQgVIyhUEIygWLHQZNGFaGmLXSgKRtykNGClCi7qzEhTFFqxYKEWhVQINAuFLrroIs6Rc+dP73sz71G1NbN5vLkz57vnO9/5zh0B0IgNwAGECYR77N5tv5QVlAVgVlL+EA8qnEEYvu1gTQGVX1AeF23zAfDq/wJ6E+SYaIurd4zeXtkoK5ax1taVa8APwDDCULWeMYvjAZQxhHX/haU6sHIBpSUp1zTiLhyfA5MoVyRhUyFGu38CGK/ATTzwG7Ba3BssNm6/tasOnPGypHxSPqkRwzgukbFfUg5WXSCcQEjJOAuct412R/cbh1HEd8y2cL0JeK+kfBQAb8VxhoxNkvqs6pWJGEDYjrIF59txFWVREr4OGPoYmCpfbqL6CrBLEi5rxDqEUwiLEvN2LaMWTyLsRdmFMNCwp/cl5s0C3Da3VAq5l7isTsvgd2+N/7CkXPcBdrCRv/hTUlY9lbkHdNAY1N0yX1+92+YwMG3rTcD7USKEUZTrKDsl9QpH27xjgpGY5/3/PONv+qo7L5GxaA75Go4jdWDlIsqID+Q4jLIHZZ/VXFs8gzBPxkNBILPaRtX6GMaGudRN4ImiG7oyzjzIu5WwSmqU8741lBlJOaQmJsdGifk9EKG/15G9stgFHOFIelE9R8brZXto2/frBMoFSRgpetv3sMRIAFwF7QDvpHobju97AYN6YU1KwlmN2Izj54K6ad8yRVv8C+AhHEu9gb0SWJGEewtRma3OSMxsXyF1LWqLpcIFS3HdArCZQMZ6Lx7HVWAOZS6MLQnfBVRbzz/ShT2P8mggrlsCXpCY3RoxjuMLlDQIusWGRA+qT5LxGY5ngT2F45UZmwue61djM40Rs0g/r5VxSbi/ys4oFIYagTMmJeW4RjwWWG0J3FfVRrFNp8XCmUwMq+VkKozjV4QHa8DimdktKaer53IDKoHHcJxqzjjjOUmZL1400ziJcgPlbrPJwoFeQJi29uqosXlGMKU04i3geAA8hePTOrAF+5ajAaUJQuT/53R/2U/V3seVD8l40c/zFk+gXC6nmrZ5D3ijG3ifxIFrRX7E/VQB5YN+TBJ+DME1YtCPRDuhmsXalMqYwbEZGJCYp4NEziFs7QRWX4epskW0jc3Pl2oZ5uZiJ437fKuVx+F8oLyCY7ufapm32aPVZGrxFMJXZbym6XSMjEMIl3rM2Ga2ldOSsLNpUVvsABbCc1qveXzjH4HmGlguptdFxJdlEGUI8YeE0e4NrdXxdnmtDvRH1u4TpjCEDTgOoHf4oy0/wRy0j7a/AXGYzkIhAeDzAAAAAElFTkSuQmCC`;

const ProductItem = ({
  item_id,
  pict_url,
  title,
  price = "",
  tlj_amount,
  onClick,
  coupon_amount,
  zk_final_price,
}) => {
  const priceString =  price ? price.toString() : '0';
  const priceList = priceString.split(".");

  if (!item_id) return <div style={"width: 47vw"} />;
  if(tlj_amount === 0) tlj_amount = null;
  return (
    <Container
      onClick={() => {
        if (onClick) {
          clickProduct(item_id);
          onClick(item_id,coupon_amount|| 0,tlj_amount || 0);
        }
      }}
    >
      <Pic src={pict_url} />

      <ProductContainer>
        <From src={Taobao} />
        {title}
      </ProductContainer>

      <Bottom>
        <PriceContainer>
          {parseFloat(price) >= 0 && (
            <TipContainer>
              补贴价 ¥<Price>{priceList && priceList[0]}</Price>{" "}
              {priceList.length > 1 && `.${priceList[1]}`}
            </TipContainer>
          )}

          <OriginPrice>¥{zk_final_price}</OriginPrice>
        </PriceContainer>

        <CouponWrapper>
          <CouponContainer>
            <CouponText>补贴券 ¥{coupon_amount}</CouponText>
          </CouponContainer>
          {tlj_amount && (
            <MoneyContainer>
              <CouponText2>补贴金 ¥{parseFloat(tlj_amount).toFixed('2')}</CouponText2>
            </MoneyContainer>
          )}
        </CouponWrapper>
      </Bottom>
    </Container>
  );
};

export default ProductItem;

const Bottom = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-end;
`;
const From = styled.img`
  width: 10px;
  height: 10px;
  position: relative;
  top: 0px;
  margin-right: 3px;
`;
const ProductContainer = styled.div`
  max-width: 40vw;
  font-size: 12px;
  color: #333;
  overflow: hidden;
  word-break:keep-all;
  white-space:nowrap;
  text-overflow:ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-left: 12px;
  margin-right: 12px;
  font-weight: 500;
  margin-top: 7px;
  line-height: 16px;
  height: 20px;
`;
const MoneyContainer = styled.div`
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 3px;
  padding-bottom: 3px;
  background: linear-gradient(90deg, #fccb87, #d79c3c);
  max-width: 20vw;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const CouponText2 = styled.div`
  color: #fff;
  font-size: 10px;
  display: inline-block;
  white-space: nowrap; 
::after{
}
`;
const CouponText = styled.div`
  color: #fff;
  font-size: 10px;
  display: inline-block;
  white-space: nowrap; 
`;

const CouponContainer = styled.div`
  background: #ee3d41;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 3px;
  padding-bottom: 3px;
  max-width: 20vw;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  ::before {
    content: "";
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #fff;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    right: -3px;
  }
  ::after {
    content: "";
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #fff;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    left: -3px;
  }
`;
const CouponWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 12px;
  margin-top: 7px;
`;
const OriginPrice = styled.div`
  font-size: 12px;
  color: #999;
  text-decoration: line-through;
`;
const Price = styled.div`
  font-size: 28px;
  font-weight: 500;
  margin-bottom: -3px;
`;
const TipContainer = styled.div`
  color: #ee3d41;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;

const PriceContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  margin-left: 10px;
  margin-right: 10px;
`;
const Container = styled.div`
  background: white;
  border-radius: 5px;
  width: 47vw;
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`;

const Pic = styled.img`
  width: 47vw;
  height: 47vw;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`;
